// Local click tracking via sendBeacon.
// Add data-track=click_track(...) to any element to fire a POST to /_action/ on click.
// Automatically appends the element's href and text as url/label query params.
document.addEventListener("click", (event) => {
  const el = event.target.closest("[data-track]");
  if (!el) return;

  const params = new URLSearchParams();
  params.set("from", window.location.pathname);

  const link = el.closest("a[href]") || el;
  const href = link.getAttribute("href");
  if (href) {
    try {
      const url = new URL(href, window.location.href);
      const isUmbc = url.hostname === window.location.hostname || url.hostname.endsWith(".umbc.edu");
      params.set("url", isUmbc ? url.pathname + url.search : url.hostname);
    } catch {
      params.set("url", href);
    }
  }

  const label = (link.textContent || "").replace(/\s+/g, " ").trim();
  if (label) params.set("label", label);

  // An optional preceding event fired on the same click. Used by search
  // suggestions to log Search.query (the typed query) before the Search.click, so
  // a typeahead click counts as a search the way the full-search path does. Sent
  // first so the query is logged ahead of the click that navigates the page away.
  if (el.dataset.trackQuery) {
    const queryParams = new URLSearchParams();
    queryParams.set("from", window.location.pathname);
    navigator.sendBeacon("/_action/" + encodeURIComponent(el.dataset.trackQuery) + "?" + queryParams);
  }

  navigator.sendBeacon("/_action/" + encodeURIComponent(el.dataset.track) + "?" + params);
}, true);
